import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from 'react-router-dom';
import * as widgetsActions from "../../../../redux/Widgets/actions";
import ChartTable from "../../../../components/Charts/ChartTable";
import ViewReportLink from "../ViewReportLink.js";
import LoadingStep from "../../../../components/LoadingStep/index.js";

const widgetName = "HotOpportunities";

const HotOpportunities = props => {
	const widget = useSelector(state => state.widget).widgets[widgetName];
	const user = useSelector(state => state.user.user);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const formatDollarAmount = (num) => {
		let formattedNum;

		// Less than 1000
		if (num < 1000) {
			formattedNum = `$${num}`;
		}
		// Thousands
		else if (num >= 1000 && num < 1_000_000) {
			formattedNum = `$${Math.round(num / 1000)}K`;
		}
		// Millions
		else if (num >= 1_000_000 && num < 1_000_000_000) {
			formattedNum = `$${Math.round(num / 1_000_000)}M`;
		}
		// Billions
		else if (num >= 1_000_000_000 && num < 1_000_000_000_000) {
			formattedNum = `$${Math.round(num / 1_000_000_000)}B`;
		}
		// Trillions
		else if (num >= 1_000_000_000_000) {
			formattedNum = `$${Math.round(num / 1_000_000_000_000)}T`;
		}

		return formattedNum;
	};

	useEffect(() => {
		const load = async () => {
			await dispatch(widgetsActions.loadWidget(widgetName))
		};
		load();
	}, [user]);

	const loading = widget == null || widget.status === "loading" || widget.data == null || widget.data.data == null ;

	if(loading) {
		return (
			<div className="widget-container">
			<div className="widget-title">Loading</div>
			<LoadingStep />
		</div>
		)
	}

	let result = [];

	widget.data?.data?.forEach(opp => {
		result.push({
			"Id": opp.Id,
			"Opportunity Name": opp.Name,
			"Status": opp.Customer_Status__c,
			"Stage": opp.StageName,
			"Amount": opp.Amount || 0
		});
	});

	let rows = JSON.parse(JSON.stringify(result));
	rows.forEach(row => {
		row.Amount = formatDollarAmount(row.Amount);
	});

	const onRowClick = async (row, index) => {
		navigate(`/opportunity/${row.Id}`);
	};

	return (
		<div className="widget-container">
			<div className="widget-title">Hot Opps ({rows.length})</div>
			<div style={{height: '100%'}}>
				<ChartTable headers={["Opportunity Name", "Status", "Stage", "Amount"]} data={rows} onRowClick={onRowClick} />
			</div>
			<ViewReportLink onClick={() => props.showReport(widget)} />
		</div>
	)
};

export default HotOpportunities;